
export const cg_search_term_overrides:Record<string,string> = {
    "disney": "disney world, orlando fl"
}